import { CircularProgress, Typography } from '@mui/material';
import styles from './style.module.scss';
import {t} from 'i18next';

const LoadingItem = (() => {
  return (
    <div className={styles.aurSelectItem}>
      <span className={styles.aurLoadingIcon}>
        <CircularProgress
          size={24}
          color="inherit"
          thickness={5}
        />
      </span>
      <span>
        <Typography className={styles.aurAllSelectLabel}>
          {t('searchableDropdown.loading')}
        </Typography>
      </span>
    </div>
  );
}
);

export default LoadingItem;
